import React, { useState, useEffect, useContext, lazy } from "react";
import api from "services/api";
import auth from "services/auth";
import ScrollTo from "elements/ScrollTo";
import swal from "sweetalert";
import ls from "services/ls";
import { useLocation } from "react-router-dom";
import { isMobile, isMobileByViewPort, cauculateLandScape } from "services/isMobile";
import LeftSide from "elements/LeftSide";
import AppContext from "contexts/AppContext";
// import LoginReg, { loginData } from "elements/LoginReg";
const StickyFooterMenu = lazy(() => import("elements/StickyFooterMenu"));
const SecurityPopup = lazy(() => import("elements/SecurityPopup"));
const GeoRestriction = lazy(() => import("elements/GeoRestriction"));
const Notification = lazy(() => import("elements/Notification"));
const LoginReg = lazy(() => import("elements/LoginReg"));
const Header = lazy(() => import("elements/Header"));
const Footer = lazy(() => import("elements/Footer"));
const Chat = lazy(() => import("elements/Chat"));
const Spinner = lazy(() => import("elements/Spinner"));

const FullLayout = ({ children, ...rest }) => {
  const location = useLocation();

  const [spinner, setSpinner] = useState(false);

  const [isLandscape, setIsLandscape] = useState(cauculateLandScape());

  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const [isMobileDeviceByViewPort, setIsMobileDeviceByViewPort] = useState(false);

  const showAlert = (title, message, isError, callback) => {
    swal({
      title: title,
      text: message,
      className: theme,
      icon: isError ? "warning" : "success",
    }).then((value) => {
      if (callback) {
        callback(value);
      }
    });
  };

  const [isAuthenticated, setIsAuthenticated] = useState(auth.isAuthenticated);
  const [userDetails, setUserDetails] = useState(auth.getUser);

  const { updateUserObj } = useContext(AppContext);
  const logout = async () => {
    await auth.logout();
    await updateUserObj();
  };

  //Get user balance functionality
  const [userBalance, setUserBalance] = useState({
    cash_balance: 0,
    bonus_balance: 0,
    total_balance: 0,
    wallets: [],
    rates: [],
  });
  const getUserBalance = async (ev) => {
    var response = await api.get("/get-balance");
    if (response.status === 401) {
      logout();
    } else {
      ls.set("conversionRates", response.data.rates);
      setUserBalance(response.data);
    }
  };

  const setUsersWallet = async (currency) => {
    var response = await api.post("/set-wallet", { currency });
    // console.log(response);
    if (response.status === 200) {
      setUserBalance(response.data);
      ls.set("conversionRates", response.data.rates);
    }
  };

  const [accountProgress, setAccountProgress] = useState(0);
  const getAccountProgress = async (ev) => {
    var response = await api.get("/account-progress");
    // console.log("accountProgress", response);
    setAccountProgress(response.data);
  };
  const [leftSidebarSlide, setLeftSidebarSlide] = useState(true);
  useEffect(() => {
    window.addEventListener("resize", () => {
      setIsLandscape(cauculateLandScape());
    });
    setIsMobileDevice(isMobile());
    setIsMobileDeviceByViewPort(isMobileByViewPort());
    if (isMobile()) {
      setLeftSidebarSlide(false);
    }
    var interval;
    if (isAuthenticated) {
      getAccountProgress();
      getUserBalance();
      setUserDetails(auth.getUser());
    }

    interval = setInterval(() => {
      if (isAuthenticated) {
        getUserBalance();
      }
    }, 5000);
    return () => {
      try {
        clearInterval(interval);
      } catch (ex) {}
    };
  }, []);

  const [searchStr, setSearchStr] = useState(""); //Used in Header.js and Games.js
  const [providers, setProviders] = useState([]); //Used in Header.js and Games.js
  const [selectedProviders, setSelectedProviders] = useState([]); //Used in Header.js and Games.js
  const getProviders = async () => {
    var response = await api.get("/games/providers");
    if (response.status === 200) {
      setProviders(response.data);
    }
  };
  const [initialSettings, setInitialSettings] = useState([]);
  const getInitialSettings = async () => {
    var response = await api.get("/initial-settings");
    if (response.status === 200) {
      setInitialSettings(response.data);
    }
  };
  useEffect(() => {
    getProviders();
    getInitialSettings();
  }, []);

  const [supportSidebarOpen, setSupportSidebarOpen] = useState(false);
  const [modalSignUpPropsData, setModalSignUpPropsData] = useState(false);
  const [modalLoginPropsData, setModalLoginPropsData] = useState(false);
  const [showLeftSidebar, setShowLeftSidebar] = useState(false);
  const [playerLiveChatSlide, setPlayerLiveChatSlide] = useState(false);

  const [openWalletModalTab, setOpenWalletModalTab] = useState(null);
  const [isChatVisible, setIsChatVisible] = useState(false);
  const [chatInPopup, setChatInPopup] = useState(null);

  const [metamaskConnected, setMetamaskConnected] = useState(false);
  const [theme, setTheme] = useState(ls.get("theme") ? ls.get("theme") : "dark");
  const [isAnonymous, setIsAnonymous] = useState(true);
  const [isRacesPageActive, setIsRacesPageActive] = useState(false);
  const getIsRacesPageActive = async () => {
    var response = await api.get("/get-content-page", {
      page_uid: "races",
    });
    if (response.status === 200) {
      setIsRacesPageActive(true);
    }
  };
  useEffect(() => {
    getIsRacesPageActive();
  }, []);

  //Social data var
  const [socialRegisterData, setSocialRegisterData] = useState({
    name: "",
    email: "",
    socialId: "",
    provider: "",
    agreeToTerms: 0,
    acceptCountryLimitation: 0,
  });

  const [depositModal, setDepositModal] = useState(false);
  const passableParams = {
    isRacesPageActive,
    showAlert,
    isMobileDevice,
    isMobileDeviceByViewPort,
    isLandscape,
    isAuthenticated,
    setSpinner,
    spinner,
    userDetails,
    userBalance,
    getUserBalance,
    setUsersWallet,
    accountProgress,
    getAccountProgress,
    searchStr,
    setSearchStr,
    providers,
    selectedProviders,
    setSelectedProviders,
    supportSidebarOpen,
    setSupportSidebarOpen,
    modalSignUpPropsData,
    setModalSignUpPropsData,
    modalLoginPropsData,
    setModalLoginPropsData,
    showLeftSidebar,
    setShowLeftSidebar,
    leftSidebarSlide,
    setLeftSidebarSlide,
    setPlayerLiveChatSlide,
    playerLiveChatSlide,
    openWalletModalTab,
    setOpenWalletModalTab,
    isChatVisible,
    setIsChatVisible,
    initialSettings,
    metamaskConnected,
    setMetamaskConnected,
    setTheme,
    theme,
    socialRegisterData,
    setSocialRegisterData,
    isAnonymous,
    setIsAnonymous,
    depositModal,
    setDepositModal,
  };

  const childrenWithProps = React.Children.map(children, (child) => {
    // Checking isValidElement is the safe way and avoids a typescript
    // error too.
    if (React.isValidElement(child)) {
      return React.cloneElement(child, passableParams);
    }
    return child;
  });

  const [inPlay, setInPlay] = useState(false);
  const playPath = location.pathname.split("/");

  useEffect(() => {
    setShowLeftSidebar(false);
  }, [location.pathname]);

  useEffect(() => {
    setInPlay(playPath.includes("play"));
  }, [playPath]);
  return (
    <>
      {/* <Spinner /> */}
      {spinner && <Spinner />}
      {!isAuthenticated && <LoginReg {...passableParams} />}
      <GeoRestriction {...passableParams} />
      {!isAuthenticated && <Notification {...passableParams} />}
      <div className={`home ${theme} ${isChatVisible && isAuthenticated ? "chat_open" : ""}`}>
        {leftSidebarSlide && isMobileDevice && (
          <>
            <div
              className="backDrop"
              onClick={() => {
                setLeftSidebarSlide(false);
              }}
            ></div>
          </>
        )}

        {!isAuthenticated && <SecurityPopup {...passableParams} />}
        {(isMobileDevice && inPlay) || <Header {...passableParams} />}
        <div
          className={
            "main_body_v1 " +
            (leftSidebarSlide ? "slideRight " : "slideLeft ") +
            (playerLiveChatSlide ? "opendPlayerLiveChat" : "")
          }
        >
          <div
            className={
              "left_bar_v1 " + (isMobileDevice ? "mobileBar " + (leftSidebarSlide ? "showMibileBar" : "") : "")
            }
          >
            <LeftSide {...passableParams} />
          </div>
          <div className={"right_bar_v1 " + (playPath.includes("games") ? "gamePage" : "")}>
            {/* {(isMobileDevice && inPlay) || <Header {...passableParams} />} */}
            <main className="container-lg">{childrenWithProps}</main>

            {(isMobileDevice && inPlay) || <Footer {...passableParams} />}
          </div>
          <div className="player_chat_sidebar_area">
            <div className="player_chat_content">Live Chat Placeholder</div>
          </div>
        </div>
      </div>
      {isMobileDevice && (!inPlay || !isLandscape) && <StickyFooterMenu {...passableParams} />}

      <ScrollTo />
      {isAuthenticated && <Chat {...passableParams} chatInPopup={chatInPopup} setChatInPopup={setChatInPopup} />}
    </>
  );
};

export default FullLayout;
